import type { UsersBulkCreateResult } from "@common/client"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { AddUsersForm } from "@/routes/_layout/settings/-components/add-users/form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/members/create",
)({
  staticData: { breadcrumb: "Add members" },
  component: AddMembersPage,
})

function AddMembersPage(): React.ReactElement {
  const navigate = useNavigate()
  const showToast = useCustomToast()

  const onSubmitted = (result: UsersBulkCreateResult) => {
    if (result.failed.length === 0) {
      showToast(
        "Success!",
        `Created ${result.created.length} member(s).`,
        "success",
      )
      navigate({ to: "/settings/workspace/members" })
      return
    }
    if (result.created.length === 0) {
      showToast(
        "No members created",
        `${result.failed.length} failed. Fix the errors and try again.`,
        "error",
      )
      return
    }
    showToast(
      "Partial Success",
      `Created ${result.created.length} member(s), ${result.failed.length} failed`,
      "success",
    )
  }

  return (
    <PageContent width="full">
      <PageTitle
        title="Add members"
        description="Passwords are generated automatically, and each member is emailed their sign-in details. Members without an email address are listed in one email to the workspace owner, so if your workspace has no owner, every member needs an email."
      />
      <AddUsersForm
        tenantId={null}
        requiresOwner={false}
        onSubmitted={onSubmitted}
      />
    </PageContent>
  )
}
